import type { Paints } from "./paints.ts"

/** The chart's own ink from the medium's paints: text, secondary labels and the grid. */
export function themeOf(paints: Paints) {
  return {
    foreground: paints("foreground"),
    muted: paints("muted-foreground"),
    grid: paints("foreground"),
    // A chart takes the fill of what it rests on: a card, the panel, a page.
    background: "transparent",
  }
}
